"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalleryMeasurer = exports.Gallery = void 0;
var react_1 = __importStar(require("react"));
// @see https://github.com/gatsbyjs/gatsby/issues/11246#issuecomment-457558245
// @see https://github.com/benhowell/react-grid-gallery
// @see http://jossmac.github.io/react-images
// @see https://github.com/xiaolin/react-image-gallery
exports.Gallery = react_1.memo(function (_a) {
    var images = _a.images, onSelect = _a.onSelect, _b = _a.maxOccupiedSpace, maxOccupiedSpace = _b === void 0 ? 0.3 : _b, _c = _a.minOccupiedSpace, minOccupiedSpace = _c === void 0 ? 0.15 : _c;
    var aspect = [];
    var adjustedWidth = [];
    var basis = [];
    var minHeight = images.reduce(function (res, _a, i) {
        var width = _a.width, height = _a.height;
        aspect[i] = width / height;
        return res < height ? res : height;
    }, Infinity);
    var maxAdjustedWidth = images.reduce(function (res, _a, i) {
        var width = _a.width, height = _a.height;
        adjustedWidth[i] = Math.round(minHeight * aspect[i]);
        return res > adjustedWidth[i] ? res : adjustedWidth[i];
    }, 0);
    images.forEach(function (photo, i) {
        basis[i] = (adjustedWidth[i] / maxAdjustedWidth) * maxOccupiedSpace;
        if (basis[i] < minOccupiedSpace)
            basis[i] = minOccupiedSpace;
    });
    var onClick = react_1.useCallback(function (e, i) {
        e.preventDefault();
        onSelect && onSelect(i);
    }, [onSelect]);
    return (react_1.default.createElement("div", { className: "react-images-grid__container" },
        react_1.default.createElement("div", { className: "react-images-grid__wrapper" }, images.map(function (_a, i) {
            var title = _a.title, thumbnail = _a.thumbnail, width = _a.width, height = _a.height, src = _a.src;
            return (react_1.default.createElement("a", { key: i, className: "react-images-grid__photo", style: {
                    backgroundImage: "url(" + thumbnail + ")",
                    flexBasis: basis[i] * 100 + '%',
                    maxWidth: basis[i] * 100 + 10 + '%',
                }, href: src, onClick: function (e) { return onClick(e, i); } }, title && react_1.default.createElement("span", { className: "react-images-grid__title" }, title)));
        }))));
});
var DefaultError = function (_a) {
    var error = _a.error;
    return react_1.default.createElement("div", null,
        "Error loading image information: ",
        error.toString());
};
var DefaultLoading = function () { return react_1.default.createElement("div", null, "Loading..."); };
var DefaultEmpty = function () { return react_1.default.createElement("div", null, "Empty Gallery"); };
var cache = new Map();
var measureImage = function (src) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (!cache.has(src)) {
            cache.set(src, new Promise(function (resolve, reject) {
                var img = new Image();
                img.onload = function () {
                    resolve({ width: img.width, height: img.height });
                };
                // img.onerror = reject;
                img.src = src;
            }));
        }
        return [2 /*return*/, cache.get(src)];
    });
}); };
exports.GalleryMeasurer = react_1.memo(function (_a) {
    var images = _a.images, _b = _a.Error, ErrorCmp = _b === void 0 ? DefaultError : _b, _c = _a.Loading, Loading = _c === void 0 ? DefaultLoading : _c, _d = _a.Empty, Empty = _d === void 0 ? DefaultEmpty : _d, props = __rest(_a, ["images", "Error", "Loading", "Empty"]);
    var _e = react_1.useState(null), resolvedImages = _e[0], setImages = _e[1];
    var _f = react_1.useState(null), error = _f[0], setError = _f[1];
    react_1.useEffect(function () {
        var mounted = true;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, _b, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, , 4]);
                        _a = mounted;
                        if (!_a) return [3 /*break*/, 2];
                        _b = setImages;
                        return [4 /*yield*/, Promise.all(images.map(function (_a) {
                                var title = _a.title, thumbnail = _a.thumbnail, src = _a.src;
                                return __awaiter(void 0, void 0, void 0, function () {
                                    var _b;
                                    return __generator(this, function (_c) {
                                        switch (_c.label) {
                                            case 0:
                                                _b = [{ title: title,
                                                        thumbnail: thumbnail,
                                                        src: src }];
                                                return [4 /*yield*/, measureImage(thumbnail)];
                                            case 1: return [2 /*return*/, (__assign.apply(void 0, _b.concat([(_c.sent())])))];
                                        }
                                    });
                                });
                            }))];
                    case 1:
                        _a = _b.apply(void 0, [_c.sent()]);
                        _c.label = 2;
                    case 2:
                        _a;
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _c.sent();
                        console.error('Error loading image information', e_1);
                        mounted && setError(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            mounted = false;
        };
    }, [images]);
    if (error)
        return react_1.default.createElement(ErrorCmp, { error: error });
    if (null === resolvedImages)
        return react_1.default.createElement(Loading, null);
    if (!resolvedImages.length)
        return react_1.default.createElement(Empty, null);
    return react_1.default.createElement(exports.Gallery, __assign({}, props, { images: resolvedImages }));
});
//# sourceMappingURL=index.js.map